import React from 'react';
import type { TFunction } from 'wix-rich-content-common';
import { GenericError } from 'wix-rich-content-ui-components';

export interface UnsupportedBlockProps {
  t: TFunction;
}

class UnsupportedBlocksComponent extends React.Component<UnsupportedBlockProps> {
  render() {
    const { t } = this.props;
    return <GenericError text={t('UnsupportedPlugin_message')} />;
  }
}

export { UnsupportedBlocksComponent as Component };
